<script>
export default {
  functional: true,
  name: 'BriqTable',
  render(h, { data, children }) {
    return h(
      'table',
      {
        class: {
          'briq-table': true,
          ...(data.staticClass && { [data.staticClass]: true }),
        },
        attrs: {
          ...data.attrs,
        },
      },
      children,
    )
  },
}
</script>

<style lang="stylus">
.briq-table
  width 100%
  border-collapse collapse
  color #2c333a

  tbody
    tr:nth-of-type(odd)
      background #f1f3f6

  > tr:nth-of-type(even)
    background #f1f3f6

  td, th
    padding 4px 12px
    border 1px solid #ececec

  &.dense
    td, th
      padding 4px 12px

.border-style-hidden
  border-style hidden

.cell-padding-8-20
  td, th
    border-style hidden
    padding 8px 20px
</style>
